import { render, staticRenderFns } from "./languages.vue?vue&type=template&id=579b042c&scoped=true&lang=html"
import script from "./languages.vue?vue&type=script&lang=js"
export * from "./languages.vue?vue&type=script&lang=js"
import style0 from "./languages.vue?vue&type=style&index=0&id=579b042c&prod&lang=css"
import style1 from "./languages.vue?vue&type=style&index=1&id=579b042c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579b042c",
  null
  
)

export default component.exports